import React from 'react';

export default function Day({ className, date, onChangeDay }) {
  return (
    <div
      className={'day' + (className ? ` ${className}` : '')}
      onClick={() => onChangeDay(date)}
    >
      <p className="text-xl leading-4">
        {date.toLocaleDateString('fa-IR', { day: 'numeric' })}
      </p>
      <p className="opacity-50  text-xs font-light">
        {date.toLocaleDateString('fa-IR', { weekday: 'long' })}
      </p>
    </div>
  );
}
